import Header from "../../components/Header/Header"
import Footer from "../../components/Footer/Footer"
import styles from "./ResultsPage.module.css"
import { useState } from 'react';

// Import hair transplant images
import hairTransplant1 from '../../assets/images/Results/hair-transplant/hair-(1).jpeg';
import hairTransplant2 from '../../assets/images/Results/hair-transplant/hair-(2).jpeg';
import hairTransplant3 from '../../assets/images/Results/hair-transplant/hair-(3).jpeg';
import hairTransplant4 from '../../assets/images/Results/hair-transplant/hair-(4).jpeg';
import hairTransplant5 from '../../assets/images/Results/hair-transplant/hair-(5).jpeg';
import hairTransplant6 from '../../assets/images/Results/hair-transplant/hair-(6).jpeg';
import hairTransplant7 from '../../assets/images/Results/hair-transplant/hair-(7).jpeg';
import hairTransplant8 from '../../assets/images/Results/hair-transplant/hair-(8).jpeg';
import hairTransplant9 from '../../assets/images/Results/hair-transplant/hair-(9).jpeg';
import hairTransplant10 from '../../assets/images/Results/hair-transplant/hair-(10).jpeg';
import hairTransplant11 from '../../assets/images/Results/hair-transplant/hair-(11).jpeg';
import hairTransplant12 from '../../assets/images/Results/hair-transplant/hair-(12).jpeg';
import hairTransplant13 from '../../assets/images/Results/hair-transplant/hair-(13).jpeg';
import hairTransplant14 from '../../assets/images/Results/hair-transplant/hair-(14).jpeg';
import hairTransplant15 from '../../assets/images/Results/hair-transplant/hair-(15).jpeg';
import hairTransplant16 from '../../assets/images/Results/hair-transplant/hair-(16).jpeg';
import hairTransplant17 from '../../assets/images/Results/hair-transplant/hair-(17).jpeg';
import hairTransplant18 from '../../assets/images/Results/hair-transplant/hair-(18).jpeg';
import hairTransplant19 from '../../assets/images/Results/hair-transplant/hair-(19).jpeg';
import hairTransplant20 from '../../assets/images/Results/hair-transplant/hair-(20).jpeg';
import hairTransplant21 from '../../assets/images/Results/hair-transplant/hair-(21).jpeg';
import hairTransplant22 from '../../assets/images/Results/hair-transplant/hair-(22).jpeg';
import hairTransplant23 from '../../assets/images/Results/hair-transplant/hair-(23).jpeg';
import hairTransplant24 from '../../assets/images/Results/hair-transplant/hair-(24).jpeg';
import hairTransplant25 from '../../assets/images/Results/hair-transplant/hair-(25).jpeg';
import hairTransplant26 from '../../assets/images/Results/hair-transplant/hair-(26).jpeg';
import hairTransplant27 from '../../assets/images/Results/hair-transplant/hair-(27).jpeg';
import hairTransplant28 from '../../assets/images/Results/hair-transplant/hair-(28).jpeg';
import hairTransplant29 from '../../assets/images/Results/hair-transplant/hair-(29).jpeg';
import hairTransplant30 from '../../assets/images/Results/hair-transplant/hair-(30).jpeg';
import hairTransplant31 from '../../assets/images/Results/hair-transplant/hair-(31).jpeg';
import hairTransplant32 from '../../assets/images/Results/hair-transplant/hair-(32).jpeg';
import hairTransplant33 from '../../assets/images/Results/hair-transplant/hair-(33).jpeg';
import hairTransplant34 from '../../assets/images/Results/hair-transplant/hair-(34).jpeg';

// Import rhinoplasty images
import rhinoplasty1 from '../../assets/images/Results/rhinoplasty/rhinoplasty-(1).jpeg';
import rhinoplasty2 from '../../assets/images/Results/rhinoplasty/rhinoplasty-(2).jpeg';
import rhinoplasty3 from '../../assets/images/Results/rhinoplasty/rhinoplasty-(3).jpeg';
import rhinoplasty4 from '../../assets/images/Results/rhinoplasty/rhinoplasty-(4).jpeg';
import rhinoplasty5 from '../../assets/images/Results/rhinoplasty/rhinoplasty-(5).jpeg';
import rhinoplasty6 from '../../assets/images/Results/rhinoplasty/rhinoplasty-(6).jpeg';
import rhinoplasty7 from '../../assets/images/Results/rhinoplasty/rhinoplasty-(7).jpeg';
import rhinoplasty8 from '../../assets/images/Results/rhinoplasty/rhinoplasty-(8).jpeg';

export default function ResultsPage() {
  const [activeTab, setActiveTab] = useState('hairTransplant');
  const [activeImage, setActiveImage] = useState('hairTransplant');

  const hairTransplantImages = [
    hairTransplant1, hairTransplant2, hairTransplant3,
    hairTransplant4, hairTransplant5, hairTransplant6,
    hairTransplant7, hairTransplant8, hairTransplant9,
    hairTransplant10, hairTransplant11, hairTransplant12,
    hairTransplant13, hairTransplant14, hairTransplant15,
    hairTransplant16, hairTransplant17, hairTransplant18,
    hairTransplant19, hairTransplant20, hairTransplant21,
    hairTransplant22, hairTransplant23, hairTransplant24,
    hairTransplant25, hairTransplant26, hairTransplant27,
    hairTransplant28, hairTransplant29, hairTransplant30,
    hairTransplant31, hairTransplant32, hairTransplant33,
    hairTransplant34
  ];

  const rhinoplastyImages = [
    rhinoplasty1, rhinoplasty2, rhinoplasty3,
    rhinoplasty4, rhinoplasty5, rhinoplasty6,
    rhinoplasty7, rhinoplasty8
  ];

  const displayedImages = activeTab === 'hairTransplant' ? hairTransplantImages : rhinoplastyImages;

  const handleToggle = (type) => {
    setActiveImage(type);
  };

  return (
    <>
      <Header />
      <main className={styles.main}>
        <div className={styles.container}>
          <h1 className={styles.title}>Results</h1>
          <div className={styles.buttonGroup}>
            <button 
              onClick={() => {setActiveTab('hairTransplant'); handleToggle('hairTransplant')}}
              className={activeTab === 'hairTransplant' ? styles.activeButton : styles.inactiveButton}
            >
              Hair Transplant
            </button>
            <button 
              onClick={() => {setActiveTab('rhinoplasty'); handleToggle('rhinoplasty')}}
              className={activeTab === 'rhinoplasty' ? styles.activeButton : styles.inactiveButton}
            >
              Rhinoplasty
            </button>
          </div>
          <div className={styles.imageGrid}>
            {activeImage === 'hairTransplant' ? (
              hairTransplantImages.map((image, index) => (
                <div key={index} className={styles.imageItem}>
                  <img 
                    src={image} 
                    alt={`Result ${index + 1}`}
                    className={styles.resultImage}
                  />
                </div>
              ))
            ) : (
              rhinoplastyImages.map((image, index) => (
                <div key={index} className={styles.imageItem}>
                  <img 
                    src={image} 
                    alt={`Result ${index + 1}`}
                    className={styles.resultImage}
                  />
                </div>
              ))
            )}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
